import { render, staticRenderFns } from "./livebofang.vue?vue&type=template&id=2840eb7f&scoped=true"
import script from "./livebofang.vue?vue&type=script&lang=js"
export * from "./livebofang.vue?vue&type=script&lang=js"
import style0 from "./livebofang.vue?vue&type=style&index=0&id=2840eb7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840eb7f",
  null
  
)

export default component.exports